import {Button} from '@hm/fundamental'
import {mdiDeleteOutline} from '@mdi/js'
import React from 'react'

import {RolePlantLookupChip} from '../../components/Role/RolePlantLookupChip'
import {GroupedRoleAssignment} from '../../modules/ManageUsers.selectors'

type PlantsProps = {
  groupedRoleAssignment: GroupedRoleAssignment
  isEditing: boolean
  handleDeletePlant?(plantId: string): void
}

export const Plants = ({groupedRoleAssignment, isEditing, handleDeletePlant}: PlantsProps) => {
  const {plantIds} = groupedRoleAssignment.variantDataScopes
  const {countryId} = groupedRoleAssignment.commonDataScopes

  if (!plantIds || plantIds.length === 0) {
    return null
  }

  return (
    <div className="flex flex-col gap-2">
      {plantIds?.map((plantId) => (
        <div key={plantId} className="flex gap-2">
          <div className="flex-1 border-1px border-border_highlight_10 rounded-lg py-2 px-3 flex flex-col items-start">
            <RolePlantLookupChip key={plantId} plantId={plantId} countryId={countryId as string} />
          </div>
          {isEditing && (
            <Button
              variant="secondary"
              type="button"
              icon={mdiDeleteOutline}
              onClick={() => {
                handleDeletePlant?.(plantId)
              }}
            >
              Remove
            </Button>
          )}
        </div>
      ))}
    </div>
  )
}
